import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiperOptions = {
        modules: [Scrollbar],
        slidesPerView: 'auto',
        spaceBetween: 10,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        }
    };

    element.swiper = new Swiper(element.querySelector(".swiper-pharms"), swiperOptions);
};